import {
  createGridGeometry,
  scaleTileExtent,
} from './projection';

const SQUARE_PROJECTION = {
  scale: 1.5,
  stepXFactor: 1,
  stepYFactor: 1,
  renderWidthFactor: 1,
  renderHeightFactor: 1,
} as const;

export const squareGrid = createGridGeometry({
  projection: SQUARE_PROJECTION,
  directions: 4,
  facingAngles: [0, 90, 180, 270],
  rotationStep: 90,
  movementAngleTolerance: 45,
  keyDirections: {
    ArrowUp: { dx: 0, dy: -1, facing: 0 },
    ArrowDown: { dx: 0, dy: 1, facing: 180 },
    ArrowLeft: { dx: -1, dy: 0, facing: 270 },
    ArrowRight: { dx: 1, dy: 0, facing: 90 },
  },
  getNextEdgeFacing(currentFacing: number, direction: 'left' | 'right') {
    const normalized = ((currentFacing % 360) + 360) % 360;
    const snapped = Math.round(normalized / 90) * 90;
    const next = snapped + (direction === 'left' ? -90 : 90);
    return ((next % 360) + 360) % 360;
  },
  neighbors(q: number, r: number) {
    return [
      { x: q, y: r - 1 },
      { x: q + 1, y: r },
      { x: q, y: r + 1 },
      { x: q - 1, y: r },
    ];
  },
  distance(x1: number, y1: number, x2: number, y2: number) {
    return Math.abs(x1 - x2) + Math.abs(y1 - y2);
  },
  isAdjacent(x1: number, y1: number, x2: number, y2: number) {
    const dx = Math.abs(x1 - x2);
    const dy = Math.abs(y1 - y2);
    return dx + dy === 1;
  },
  drawTilePath(ctx: CanvasRenderingContext2D, cx: number, cy: number, size: number) {
    const half = scaleTileExtent(size, SQUARE_PROJECTION);
    ctx.beginPath();
    ctx.rect(cx - half, cy - half, half * 2, half * 2);
  },
  fillTile(ctx: CanvasRenderingContext2D, cx: number, cy: number, size: number) {
    const half = scaleTileExtent(size, SQUARE_PROJECTION);
    ctx.fillRect(cx - half, cy - half, half * 2, half * 2);
  },
});
